import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "input-container" }
const _hoisted_3 = { class: "navigation" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "navigation" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "no-stickers"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_StickersComponent = _resolveComponent("StickersComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", null, [
        _createVNode(_component_router_link, { to: { name: 'home' } }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "header-sticker" }, " STICKERS ", -1)
          ])),
          _: 1
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        placeholder: "SEARCH",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
        onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchInputChanged && _ctx.searchInputChanged(...args)))
      }, null, 544), [
        [_vModelText, _ctx.query]
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.showWithoutText)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " you're looking at stickers without any text on them "))
          : _createCommentVNode("", true),
        (!_ctx.showWithoutText)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: { name: 'without_text' }
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" see stickers without any text on them ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!_ctx.query && !_ctx.showWithoutText)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, " you're looking at all stickers "))
          : _createCommentVNode("", true),
        (_ctx.showWithoutText || _ctx.query)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: { name: 'home' }
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" see all stickers ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "navigation related" }, [
        _createElementVNode("a", {
          href: "https://mwarning.github.io/chaos-sticker-collection/",
          target: "_blank",
          rel: "noopener"
        }, "[1]"),
        _createElementVNode("span", { class: "related-label" }, "← related work →"),
        _createElementVNode("a", {
          href: "https://stickertop.art/",
          target: "_blank",
          rel: "noopener"
        }, "[2]")
      ], -1))
    ]),
    _createVNode(_component_StickersComponent, { stickers: _ctx.stickers }, null, 8, ["stickers"]),
    (_ctx.stickers.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, " there are no stickers that match this query "))
      : _createCommentVNode("", true)
  ]))
}